import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

function initSwiper() {
  const swiper = new Swiper('.-js-top-coloum-swiper', {
    modules: [Navigation],

    slidesPerView: 'auto',
    navigation: {
      nextEl: '.swiper-button.-next',
      prevEl: '.swiper-button.-prev',
    },
  })
}

export default function topColoumSwiper() {
  // 画面の幅を取得
  const screenWidth = window.innerWidth

  // 768px以下の場合のみSwiperを初期化
  if (screenWidth <= 768) {
    initSwiper()
  }

  // ウィンドウのリサイズ時にもチェック
  window.addEventListener('resize', () => {
    const newScreenWidth = window.innerWidth
    if (newScreenWidth <= 768) {
      initSwiper()
    }
  })
}
